// extracted by mini-css-extract-plugin
export default {"container":"MenuGroup_container__iqChn","wrapper":"MenuGroup_wrapper__iZn1f","title":"MenuGroup_title__nKvi2","content":"MenuGroup_content__ACScj"};